// function used to get what steps (inputgroupings) should be rendered based on the evaluation selected
import getInputGroupings from '../Scripts/_getInputGroupings'

export default function getSteps(currentAthleteProgram) 
{    
    let inputGroupingsObject = getInputGroupings('Gold',currentAthleteProgram);

    // build list of steps
    var groupingInputsNames = []
    var i = 0
    for (i in inputGroupingsObject) 
      groupingInputsNames.push(inputGroupingsObject[i].groupName); // append values to array
    
    return groupingInputsNames
  }